import React from "react";
import { Link } from "react-router-dom";

const AgencyOverviewCard = ({ agencyOverview, agencyLoading }) => {
  return (
    <div className="w-full lg:flex-[73]">
      <h2 className="text-xl font-semibold mb-2">Your agency overview</h2>
      <div className="bg-white rounded-lg p-4 md:p-6 h-full flex flex-col">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-auto border border-[#D6DBEA] p-4 md:p-10 rounded-xl">
          <div className="">
            <div className="flex items-center gap-2 text-secondary mb-2">
              <div className="w-2 h-2 rounded-full bg-[#F8F9FB] border border-[#1A212F]"></div>
              <span className="text-xs font-medium text-[#8491A5]">
                Total pitches
              </span>
            </div>
            <p className="text-2xl font-semibold ml-4 md:ml-14">
              {agencyLoading ? "..." : agencyOverview?.totalPitches || "0"}
            </p>
          </div>
          <div>
            <div className="flex items-center gap-2 text-secondary mb-2">
              <div className="w-2 h-2 rounded-full bg-[#7E8BFF]/20 border border-[#2283FF]"></div>
              <span className="text-xs font-medium text-[#8491A5]">
                Ongoing pitches
              </span>
            </div>
            <p className="text-2xl font-semibold ml-4 md:ml-14">
              {agencyLoading ? "..." : agencyOverview?.ongoingPitches || "0"}
            </p>
          </div>
          <div className="border-none sm:border-r border-[#D6DBEA]">
            <div className="flex items-center gap-2 text-secondary mb-2">
              <div className="w-2 h-2 rounded-full bg-[#F5FCF6] border border-[#00C7BE]"></div>
              <span className="text-xs font-medium text-[#8491A5]">
                Accepted pitches
              </span>
            </div>
            <p className="text-2xl font-semibold ml-4 md:ml-14">
              {agencyLoading ? "..." : agencyOverview?.acceptedPitches || "0"}
            </p>
          </div>
          <div>
            <div className="flex items-center gap-2 text-secondary mb-2">
              <div className="w-2 h-2 rounded-full bg-[#F4E3ED] border border-[#FF2D55]"></div>
              <span className="text-xs font-medium text-[#8491A5]">
                Rejection rate
              </span>
            </div>
            <p className="text-2xl font-semibold ml-4 md:ml-14">
              {agencyLoading ? "..." : agencyOverview?.rejectionRate || "0%"}
            </p>
          </div>
        </div>

        <Link
          to="/agency/pitches"
          className="w-full text-center md:w-fit mt-4 items-center text-sm text-[#1E1E1E] font-medium border border-[#E6E6E6] rounded-lg px-4 py-2 flex justify-center"
        >
          Go to agency pitches
        </Link>
      </div>
    </div>
  );
};

export default AgencyOverviewCard;
